import axios from "axios";
import api, { ApiResponse } from "./../api";
import {
    CarrierDetailModel,
} from "./models";
import { PageResponseModel } from "../common/models";

export const REQUEST_ID: {
    [key: string]: string;
} = {
    GET_CARRIERS_LIST: "get_carriers_list",
    GET_CARRIERS_DETAIL: "get_carriers_detail",
    GET_DOWNLOAD_CARRIER: "get_download_carrier",
};

class CarrierService {
    private source: any;
    private static instance: CarrierService;
    private constructor() {
        this.source = {};
    }
    static getInstance(): CarrierService {
        if (!CarrierService.instance) {
            CarrierService.instance = new CarrierService();
        }
        return CarrierService.instance;
    };

    public cancelRequest = (requestId: string) => {
        this.source[requestId] && this.source[requestId].cancel();
    }

    public getcarriersList = async (
        search?: string,
        page?: number
    ): Promise<ApiResponse<PageResponseModel<CarrierDetailModel>>> => {
        const params = new URLSearchParams();

        if (search && search.trim() !== "") {
            params.append("search", search);
        }

        if (page !== undefined) {
            params.append("page", page.toString());
        }

        this.cancelRequest(REQUEST_ID.GET_CARRIERS_LIST);
        this.source[REQUEST_ID.GET_CARRIERS_LIST] = axios.CancelToken.source();

        return await api.get("/carrier", {
            params,
            cancelToken: this.source[REQUEST_ID.GET_CARRIERS_LIST].token
        });
    };

    public getCarrierDetails = async (
        carrierNumber: number,
        page?: number
    ): Promise<ApiResponse<PageResponseModel<CarrierDetailModel>>> => {
        const params = new URLSearchParams();

        if (page !== undefined) {
            params.append("page", page.toString());
        }

        this.cancelRequest(REQUEST_ID.GET_CARRIERS_DETAIL);
        this.source[REQUEST_ID.GET_CARRIERS_DETAIL] = axios.CancelToken.source();

        return await api.get(`/carrier/${carrierNumber}`, {
            params,
            cancelToken: this.source[REQUEST_ID.GET_CARRIERS_DETAIL].token
        });
    };

    public createCarrier = async (payload: any) => {
        try {
            const res = await api.post("/carrier", payload);
            if (res.status !== 200) {
                throw new Error(res.data?.errors?.[0]?.message || "Something went wrong");
            }
            return res;
        } catch (err: any) {
            const msg =
                err?.response?.data?.errors?.[0]?.message ||
                err.response?.data?.error ||
                err.message ||
                "Failed to create carrier";
            throw new Error(msg);
        }
    };

    public updateCarrier = async (id: number, payload: any) => {
        try {
            const res = await api.put(`/carrier/${id}`, payload);
            if (res.status !== 200) {
                throw new Error(res.data?.errors?.[0]?.message || "Something went wrong");
            }
            return res;
        } catch (err: any) {
            const msg =
                err?.response?.data?.errors?.[0]?.message ||
                err.response?.data?.error ||
                err.message ||
                "Failed to update carrier";
            throw new Error(msg);
        }
    };

    public deleteCarrier = async (id: number) => {
        try {
            const res = await api.delete(`/carrier/${id}`);
            if (res.status !== 200) {
                throw new Error(res.data?.message || "Something went wrong");
            }
            return res;
        } catch (err: any) {
            const msg =
                err.response?.data?.message ||
                err.response?.data?.error ||
                err.message ||
                "Failed to delete carrier";
            throw new Error(msg);
        }
    };


    public getDownloadCSVCarrier = async (
        search: string,
    ): Promise<Blob> => {
        const params = new URLSearchParams();

        if (search && search.trim() !== "") {
            params.append("search", search);
        }

        this.cancelRequest(REQUEST_ID.GET_DOWNLOAD_CARRIER);
        this.source[REQUEST_ID.GET_DOWNLOAD_CARRIER] = axios.CancelToken.source();

        const response = await api.get("/carrier/export", {
            params,
            cancelToken: this.source[REQUEST_ID.GET_DOWNLOAD_CARRIER].token,
            responseType: "blob",
        });

        return response.data;
    };

};

export default CarrierService;